/**
 * Computes the maximum height for a Radix Select Viewport so that at most
 * `maxVisibleItems` items are visible. Remaining items become accessible via
 * the native scrollbar.
 *
 * The height is the sum of the first N item heights plus the viewport's
 * vertical padding, so it always lines up exactly with the item boundaries
 * regardless of theme/font changes.
 *
 * Returns `undefined` when measurement is not possible yet (viewport not
 * mounted or no items rendered).
 */
export const measureViewportMaxHeight = (
  viewport: HTMLElement | null,
  maxVisibleItems = 3,
  itemSelector = '[data-slot="select-item"]'
): number | undefined => {
  if (!viewport) {
    return undefined;
  }

  const items = viewport.querySelectorAll<HTMLElement>(itemSelector);
  if (items.length === 0) {
    return undefined;
  }

  const visibleCount = Math.min(maxVisibleItems, items.length);

  let total = 0;
  for (let i = 0; i < visibleCount; i++) {
    total += items[i].offsetHeight;
  }

  const styles = window.getComputedStyle(viewport);
  total += parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

  return total;
};
